// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__35DFH","tab":"ProcedureTabs_tab__1lHP_"};